import React from "react";
import {Modal} from "@mui/material";
import {isEqual} from "lodash";
import {useViewController} from "data/services/locator/locator_hook.service";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {ModalType} from "data/enums";
import {observer} from "mobx-react";
import {Bindings} from "data/constants/bindings";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {ReactComponent as IconInfo} from "assets/img/icon/icon-info-gold.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {PrimaryButton, SecondaryButton} from "views/components/style";
import {BASE_URL} from "data/constants";
import {LinkLabel} from "views/components/form";
import {NavLink} from "react-router-dom";

export const LosePicks: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {i18n, visibleModal, close} = controller;
	const isVisible = isEqual(visibleModal, ModalType.LOSE_PICKS);

	if (!isVisible) {
		return null;
	}

	const title = i18n.t("modal.lose_picks.title", "DONT LOSE YOUR TEAM!");
	const message = i18n.t("modal.lose_picks.description", "Lorem lorem lorem lorem lorem lorem");
	const terms = i18n.t("modal.lose_picks.terms", "View Terms and Conditions.");

	return (
		<Modal open={isVisible} onClose={close}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconInfo />
					</ModalHeader>
					<ModalBody>
						<ModalTitle>{title}</ModalTitle>
						<ModalText>
							{message}{" "}
							<NavLink to={`help/terms`} target={"_blank"}>
								<LinkLabel>{terms}</LinkLabel>
							</NavLink>
						</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ModalFooter>
						<SecondaryButton
							onClick={close}
							href={`${BASE_URL}/registration`}
							fullWidth
							variant="contained"
							size="large"
							style={{maxWidth: "320px"}}>
							{i18n.t("page.register.button_register", "Register")}
						</SecondaryButton>
						<PrimaryButton
							fullWidth
							onClick={close}
							href={`${BASE_URL}/login`}
							variant="contained"
							size="large">
							{i18n.t("page.login.login_copy", "Log In")}
						</PrimaryButton>
					</ModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
